import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { AcademyScene } from './scenes/AcademyScene';
import { ZoneScene } from './scenes/ZoneScene';
import { CombatScene } from './scenes/CombatScene';

export function createGame(parent: HTMLElement): Phaser.Game {
  return new Phaser.Game({
    type: Phaser.AUTO,
    parent,
    backgroundColor: '#1b1530',
    scale: {
      mode: Phaser.Scale.RESIZE,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: parent.clientWidth,
      height: parent.clientHeight,
    },
    physics: { default: 'arcade', arcade: { gravity: { x: 0, y: 0 }, debug: false } },
    scene: [BootScene, AcademyScene, ZoneScene, CombatScene],
    audio: { disableWebAudio: false },
  });
}
